export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/balances": [5],
		"/dashboard": [6],
		"/explorer": [7],
		"/explorer/channels": [8],
		"/explorer/clients": [9],
		"/explorer/connections": [10],
		"/explorer/packets": [11],
		"/explorer/packets/[packet_hash]": [12,[2]],
		"/explorer/tokens": [13],
		"/explorer/transfers": [14],
		"/explorer/transfers/[packet_hash]": [15,[3]],
		"/faucet": [16],
		"/stake": [17],
		"/transfers": [22],
		"/transfer": [18],
		"/transfer/multisig": [19],
		"/transfer/native": [20],
		"/transfer/ts-packets": [21]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';